import { Payments } from "@/constants";
import { cn, createBEM } from "@/libs";
import { useConfigContext } from "@/app";
import { formatPaymentListItem, usePaymentsStore } from "@/stores/payments";
import { useBankStore } from "@/stores/banks";
import { ComponentBase } from "@/types";
import tools, { parsePayments } from "@/utils/tool";
import { useLatest } from "ahooks";
import { CheckList, Collapse, Selector, SelectorOption, Toast } from "antd-mobile";
import { AddCircleOutline, CheckCircleFill, CheckCircleOutline, CheckOutline } from "antd-mobile-icons";
import { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DialogLocal } from "../Dialog";
import { Icon, IconName } from "../Icon";
import "./index.scss";
import { useCryptoPayments } from "@/stores/CryptoTradingStore";
import { safeRealName } from "@/utils/safe";
const b = createBEM("i-payment-selector");
const iconMap: Record<Payments, IconName> = {
  [Payments.CRYPTO_COIN]: 'USDT',
  [Payments.DIGITAL_RMB]: 'digital_rmb',
  [Payments.BANK]: 'bank',
  [Payments.WE_CHAT]: 'wechat',
  [Payments.ALI]: 'alipay',
  [Payments.WX_GROUP]: 'wechat'
};
export const PaymentLabelTemplate = ({
  name,
  description,
  icon
}: {
  name: ReactNode;
  description?: ReactNode;
  icon: Payments;
}) => {
  return <div className={b("payment")} data-sentry-component="PaymentLabelTemplate" data-sentry-source-file="index.tsx">
      <Icon name={iconMap[icon]} size="20px" data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
      {description && <span>{description}</span>}
    </div>;
};
export const PaymentOptions: SelectorOption<Payments>[] = [{
  description: "银行卡",
  label: "bank",
  value: Payments.BANK
}, {
  description: "微信",
  label: "wechat",
  value: Payments.WE_CHAT
}, {
  description: "支付宝",
  label: "alipay",
  value: Payments.ALI
}, {
  description: "USDT地址",
  label: "USDT地址",
  value: Payments.CRYPTO_COIN
}, {
  description: "数字人民币",
  label: "数字人民币",
  value: Payments.DIGITAL_RMB
}, {
  description: "微信聚合",
  label: "微信聚合",
  value: Payments.WX_GROUP
}];
export interface PaymentSelectorProps extends ComponentBase.Component {
  onChange: (ids: [paymentType: number, PaymentTypeId: string]) => void;
  validPayments?: Payments; // 目标用户支持的支付方式
}
export interface PaymentSelectorSellerProps extends ComponentBase.Component {
  onChange: (ids: Record<Payments, null | string>) => void;
  validPayments?: Payments; // 目标用户支持的支付方式
  isBuyer?: boolean;
}
export const PaymentSelector = ({
  className,
  onChange,
  validPayments,
  // @ts-ignore
  isBuyer = false
}: PaymentSelectorProps | PaymentSelectorSellerProps) => {
  const navigate = useNavigate();
  // 格式化后的支付方式列表
  // const [formatPayments, userPayments] = usePaymentsStore((state) => [
  //   state.formatPayments,
  //   state.payments,
  // ]);

  const {
    formatPayments,
    userPayments,
    hideAlipayWechat,
    hideProfessionAlipayWechat,
    isMerchant,
    isProfession
  } = useCryptoPayments();
  // 单选当前选中的支付通道，用户购买时只能单选
  // const [payment, setPayment] = useState(Payments.BANK);
  const [payment, setPayment] = useState<any>('');
  // 多选选中支付通道，用户卖单的时候可以选择可接收的支付方式
  const [payments, setPayments] = useState<any>([]);
  // const [payments, setPayments] = useState([Payments.BANK.toString()]);
  // 初始化选择器记录
  const ChannelMapId: Record<Payments, null | string> = {
    [Payments.BANK]: null,
    [Payments.ALI]: null,
    [Payments.WE_CHAT]: null,
    [Payments.CRYPTO_COIN]: null,
    [Payments.DIGITAL_RMB]: null,
    [Payments.WX_GROUP]: null
  };
  // 记录当前选中的，以及设置初始化值
  const [channelMapId, setChannelMapId] = useState(ChannelMapId);
  const latestChannelMapId = useLatest(channelMapId);
  // 有效的支付方式，取决于当前用户
  let valids = !validPayments ? userPayments : parsePayments(validPayments!); // 转换为数字
  console.log('valids==', valids);
  if (isProfession) {
    valids.unshift(6);
  }
  console.log('validPayments==', validPayments);
  const validsMap: Record<Payments, Payments> = (valids.reduce((p, c) => ({
    [c]: c,
    ...p
  }), {}) as Record<Payments, Payments>);
  // 买单时过滤掉无效的支付渠道，由于卖家的支付方式为多对多所以需要过滤无效值
  console.log('PaymentOptions==', PaymentOptions);
  const showOptions = PaymentOptions.filter(item => {
    if (item.value === Payments.CRYPTO_COIN) return false;
    if (!isBuyer && isMerchant && item.value === Payments.DIGITAL_RMB) return false;
    if (item.value && !formatPayments[item.value]?.list?.length) return false;
    if (!isBuyer && isProfession && !hideProfessionAlipayWechat) {
      return true;
    }
    if (!isBuyer && isProfession && item.value === Payments.WX_GROUP) {
      //超级商家 展示微信聚合
      return true;
    }
    if (!isBuyer && isMerchant && hideAlipayWechat) {
      if (item.value === Payments.ALI || item.value === Payments.WE_CHAT) {
        return false;
      } else {
        return true;
      }
    } else if (!isBuyer && isProfession && hideProfessionAlipayWechat) {
      //超级商家 隐藏wx alipay
      if (item.value === Payments.ALI || item.value === Payments.WE_CHAT) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  });
  console.log('showOptions==', showOptions);
  console.log('formatPayments==', formatPayments);
  console.log('validsMap==', validsMap);
  const _options = showOptions.map(item => {
    const _item = Object.assign({}, item);
    const _payment = formatPayments[_item.value || '1'];
    const _valid = validsMap[_item.value || '1'];
    if (tools.isUndefined(_payment) || tools.isUndefined(_valid)) {
      _item.disabled = true;
    }
    _item.description = "";
    _item.label = <PaymentLabelTemplate name={item.label} description={item.description} icon={(item.value as Payments)} />;
    console.log('_item==', _item);
    return _item;
  }).filter(item => !item.disabled);
  console.log('_options==', _options);
  // 是否有支付方式
  const isPaymentValid = valids.length !== 0;
  // 获取每个渠道对应的默认支付账号 第一个账号
  const getDefaultValue = (payment: Payments) => String((formatPayments[payment]?.list || [])[0]?.id || "");
  // 单选账号选中时添加记录对应渠道和账号
  const _onChange = (accountId: string, _payment: Payments) => {
    const _channelMapId = {
      ...latestChannelMapId.current
    };
    _channelMapId[_payment] = accountId;
    setChannelMapId(_channelMapId);
  };
  useEffect(() => {
    if (!isPaymentValid || !_options.length) {
      DialogLocal({
        title: "提示",
        content: "您还未绑定该支付方式的支付账号,请绑定对应支付账号后再选择该支付方式",
        confirmText: "去绑定",
        cancelText: "取消",
        async onConfirm() {
          navigate(isMerchant ? isProfession ? "/payment/professionBusiness" : "/payment/merchant" : "/payment");
          return true;
        },
        onCancel: () => {
          return Promise.resolve(true);
        }
      });
    } else {
      if (validPayments) {
        //非卖币出售  默认选中
        const option = _options[0];
        _onChange(getDefaultValue((option.value as Payments)), (option.value as Payments));
        setPayment(option.value);
        setPayments([`${option.value}`]);
      }
    }
  }, []);
  useEffect(() => {
    if (!isPaymentValid) return;
    if (!validPayments) {
      (onChange as PaymentSelectorSellerProps["onChange"])(channelMapId);
    } else {
      (onChange as PaymentSelectorProps["onChange"])([payment, channelMapId[(payment as Payments)] || ""]);
    }
  }, [channelMapId]);

  // 渲染渠道对应的账号列表
  const PaymentAccunts = ({
    payment
  }: {
    payment: Payments;
  }) => {
    const defaultValue = isPaymentValid ? latestChannelMapId.current[payment] || getDefaultValue(payment) : "";
    const getOptions = (cb: (item: formatPaymentListItem) => PaymentOptions) => {
      if (isPaymentValid) {
        return (formatPayments[payment]?.list || []).map(cb);
      } else {
        return [];
      }
    };
    switch (payment) {
      case Payments.BANK:
        return <PaymentList defaultValue={defaultValue} onChange={v => _onChange(v, payment)} payment={payment} type="bank" options={getOptions(item => {
          return {
            name: item.bankId,
            account: item.bankNo,
            id: String(item.id)
          };
        })} />;
      case Payments.ALI:
        return <PaymentList defaultValue={defaultValue} onChange={v => _onChange(v, payment)} payment={payment} type="app" options={getOptions(item => {
          return {
            name: item.realName,
            account: item.alipayAccount,
            id: String(item.id),
            img: item.receiptCode
          };
        })} />;
      case Payments.WE_CHAT:
        return <PaymentList defaultValue={defaultValue} onChange={v => _onChange(v, payment)} payment={payment} type="app" options={getOptions(item => {
          return {
            name: item.realName,
            account: item.wxRealname,
            id: String(item.id),
            img: item.receiptCode
          };
        })} />;
      case Payments.WX_GROUP:
        return <PaymentList defaultValue={defaultValue} onChange={v => _onChange(v, payment)} payment={payment} type="app" options={getOptions(item => {
          return {
            name: item.realName,
            account: item.wxRealname,
            id: String(item.id),
            img: item.receiptCode
          };
        })} />;
      case Payments.CRYPTO_COIN:
        return <PaymentList defaultValue={defaultValue} onChange={v => _onChange(v, payment)} payment={payment} type="app" options={getOptions(item => {
          return {
            name: item.realName,
            account: item.wxRealname,
            id: String(item.id),
            img: item.receiptCode
          };
        })} />;
      case Payments.DIGITAL_RMB:
        return <PaymentList defaultValue={defaultValue} onChange={v => _onChange(v, payment)} payment={payment} type="app" options={getOptions(item => {
          return {
            name: item.realName,
            account: item.digitalAddress,
            id: String(item.id),
            img: item.receiptCode
          };
        })} />;
      default:
        return <></>;
    }
  };
  // 卖家选择支付方式，此时为多选
  if (!validPayments) {
    return <div className={cn(b(), className)}>
        <Collapse
      // defaultActiveKey={isPaymentValid ? [String(payment)] : []}
      activeKey={isPaymentValid ? payments : []} onChange={keys => {
        // 多选时存在减少的情况，同样要处理减少时对应的账号id修改为null
        const _channelMapId = ({
          ...ChannelMapId
        } as any);
        Object.keys(_channelMapId).forEach(key => {
          if (!keys.includes(key)) {
            _channelMapId[key] = null;
          }
        });
        keys.forEach(key => {
          const payment = (Number(key) as Payments);
          _channelMapId[payment] = latestChannelMapId.current[payment] || getDefaultValue(payment);
        });
        if (keys) {
          setChannelMapId(_channelMapId);
          // setPayments(keys.length ? keys : [Payments.BANK.toString()]); // 默认银行卡
          setPayments(keys.length ? keys : []);
        } else {
          Toast.show('您还未绑定该支付方式的支付账号,请绑定对应支付账号后再选择该支付方式');
        }
      }}>
          {_options.map(item => {
          return <Collapse.Panel destroyOnClose key={String(item.value)} title={item.label} disabled={item.disabled || !item.value || !formatPayments[item.value]?.list?.length} arrow={active => {
            if (!item.value || !formatPayments[item.value]?.list?.length) {
              return <div style={{
                fontSize: '12px'
              }}>未绑定该支付方式的支付账号</div>;
            }
            return active ? <CheckOutline color="#01B14E" /> : <AddCircleOutline />;
          }}>
                <PaymentAccunts payment={item.value!} />
              </Collapse.Panel>;
        })}
        </Collapse>
      </div>;
  } else {
    return <div className={cn(b(), className)}>
        <Selector value={[payment]} options={_options} onChange={keys => {
        const _channelMapId = {
          ...ChannelMapId
        };
        keys.forEach(key => {
          const payment = (Number(key) as Payments);
          _channelMapId[payment] = latestChannelMapId.current[payment] || getDefaultValue(payment);
        });
        setChannelMapId(_channelMapId);
        setPayment(keys[0]);
      }} />
        <PaymentAccunts payment={payment} />
      </div>;
  }
};
export interface PaymentOptions {
  name?: string;
  account?: string;
  id: string;
  img?: string;
}
export interface PaymentListProps extends ComponentBase.Component {
  defaultValue: string;
  options: PaymentOptions[];
  type: "bank" | "app";
  payment: Payments;
  onChange: (id: string) => void;
}
export const PaymentList = ({
  defaultValue,
  options,
  type,
  payment,
  onChange
}: PaymentListProps) => {
  const [active, setActive] = useState(defaultValue);
  const [bankMap] = useBankStore(state => [state.bankMap]);
  const {
    getSourcePath
  } = useConfigContext();
  console.log('options==', options);
  return <CheckList value={[active]} className={b(type)} extra={active => active ? <CheckCircleFill /> : <CheckCircleOutline />} defaultValue={[active]} onChange={arr => {
    onChange(`${arr[0] || options[0].id}`);
    setActive(`${arr[0] || options[0].id}`);
  }} data-sentry-element="CheckList" data-sentry-component="PaymentList" data-sentry-source-file="index.tsx">
      {options.map(item => {
      if (type === "bank") {
        return <CheckList.Item value={item.id} key={item.id}>
              <div className={b("bank-name")}>{item.name ? bankMap?.[(item.name as any)] || item.name : ""}</div>
              <div className={b("bank-account")}>
                后4位{" "}
                {(item.account || "").substring((item.account || "").length - 4)}
              </div>
            </CheckList.Item>;
      }
      if (payment === Payments.ALI) {
        return <CheckList.Item className={b("ali-item")} value={item.id} key={item.id}>
              <div className={b("app-name")}>
                支付宝账号 <span className={b("app-span")}>{item.account}</span>
              </div>
              <div className={b("app-account")}>
                姓名 <span className={b("app-span")}>{item.name}</span>
              </div>
              <img className={b("app-pay-img")} src={getSourcePath(item.img)} alt="" />
            </CheckList.Item>;
      }
      if (payment === Payments.WE_CHAT || payment === Payments.WX_GROUP) {
        return <CheckList.Item className={b("wx-item")} value={item.id} key={item.id}>
              <div className={b("app-name")}>
                微信真实姓名：{item.account}
                <p className={b("app-wxname")}>微信名：{safeRealName(item.name)}</p>
              </div>
              {/* <div className={b("app-account")}>
                <span>{item.account}</span>
               </div> */}
              <img className={b("app-pay-img")} src={getSourcePath(item.img)} alt="" />
            </CheckList.Item>;
      }
      if (payment === Payments.CRYPTO_COIN) {
        return <CheckList.Item value={item.id} key={item.id}>
              <div className={b("app-name")}>USDT地址</div>
              <div className={b("app-account")}>
                <span>{item.name}</span>
              </div>
            </CheckList.Item>;
      }
      if (payment === Payments.DIGITAL_RMB) {
        return <CheckList.Item value={item.id} key={item.id}>
              <div className={b("app-name")}>{item.name}</div>
              <div className={b("app-account")}>
                <span>{item.account}</span>
              </div>
            </CheckList.Item>;
      }
      return <></>;
    })}
    </CheckList>;
};